import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { HeaderService } from '@app/service/header/header.service';
import { StateService } from '@app/service/state/state.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SERVER_BASE_URL } from 'src/environments/environment';
import { delay, filter, repeatWhen } from 'rxjs/operators';
import { QueryParamsService } from '@app/service/query-params/query-params.service';
import { RouteComponent } from '@app/route/route.component';

@Component({
  selector: 'se-transition-poll',
  templateUrl: './se-transition-poll.component.html',
  styleUrls: ['./se-transition-poll.component.scss'],
})
export class SeTransitionPollComponent extends RouteComponent implements OnInit {
  constructor(
    private http: HttpClient,
    protected stateService: StateService,
    protected headerService: HeaderService,
    protected router: Router,
    protected route: ActivatedRoute,
    private queryParamsService: QueryParamsService,
  ) {
    super(router, route, stateService, headerService);
  }

  pollingSubscription: Subscription;
  loading: boolean = true;

  ngOnInit(): void {
    const messageId = this.queryParamsService.getQueryParams().messageId;
    const resumeToken = this.queryParamsService.getQueryParams().resumeToken;

    let params = new HttpParams();
    if (messageId !== undefined) {
      params = params.append('messageId', messageId);
      params = params.append('resumeToken', resumeToken);
    }
    this.pollingSubscription = this.http
      .get<any>(`${SERVER_BASE_URL}/user/se/directDebit/account/selected`, {
        withCredentials: true,
        params: params
      })
      .pipe(
        repeatWhen((obs) => obs.pipe(delay(2000))),
        filter((res) => res?.mandateStatus === 'PENDING' || res?.mandateStatus === 'APPROVED')
      )
      .subscribe((res) => this.handleUpdate(res));
  }

  async handleUpdate(res: any) {
    const isInIframe = window.self !== window.top;

    if (!isInIframe || res?.isResumedSession) {
      this.pollingSubscription?.unsubscribe();
        this.stateService.setToken(res?.checkoutToken);
        await this.navigate();
        return;
    } else {
      this.loading = false;
      this.pollingSubscription?.unsubscribe();
      (window.parent as any).postMessage({ success: true });
      return;
    }
  }
}
